/* Elizalde pendant + chain preview: lifts the pendant out of its product photo and hangs it on the chosen chain's photo */
(function () {
  'use strict';
  var cache = {};

  function load(url) {
    if (!cache['i' + url]) {
      cache['i' + url] = new Promise(function (resolve, reject) {
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () { resolve(img); };
        img.onerror = reject;
        img.src = url;
      });
    }
    return cache['i' + url];
  }

  /* Square min / max filter on a 0/1 mask (erode when isMax is false, dilate when true) */
  function filter(src, W, H, r, isMax) {
    var tmp = new Uint8Array(W * H), out = new Uint8Array(W * H), x, y, k, v, a, b;
    for (y = 0; y < H; y++) {
      var row = y * W;
      for (x = 0; x < W; x++) {
        v = isMax ? 0 : 1;
        if (!isMax && (x - r < 0 || x + r >= W)) v = 0;
        else for (a = Math.max(0, x - r), b = Math.min(W - 1, x + r), k = a; k <= b; k++) { if (isMax ? src[row + k] : !src[row + k]) { v = isMax ? 1 : 0; break; } }
        tmp[row + x] = v;
      }
    }
    for (x = 0; x < W; x++) {
      for (y = 0; y < H; y++) {
        v = isMax ? 0 : 1;
        if (!isMax && (y - r < 0 || y + r >= H)) v = 0;
        else for (a = Math.max(0, y - r), b = Math.min(H - 1, y + r), k = a; k <= b; k++) { if (isMax ? tmp[k * W + x] : !tmp[k * W + x]) { v = isMax ? 1 : 0; break; } }
        out[y * W + x] = v;
      }
    }
    return out;
  }

  function pixels(img, W) {
    var H = Math.round(img.naturalHeight * W / img.naturalWidth);
    var c = document.createElement('canvas');
    c.width = W; c.height = H;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, W, H);
    var data = ctx.getImageData(0, 0, W, H);
    var p = data.data, bg = [0, 0, 0];
    [[2, 2], [W - 3, 2], [2, H - 3], [W - 3, H - 3]].forEach(function (pt) {
      var i = (pt[1] * W + pt[0]) * 4;
      bg[0] += p[i] / 4; bg[1] += p[i + 1] / 4; bg[2] += p[i + 2] / 4;
    });
    var diff = new Uint8Array(W * H);
    for (var i = 0; i < W * H; i++) {
      var q = i * 4;
      diff[i] = Math.max(Math.abs(p[q] - bg[0]), Math.abs(p[q + 1] - bg[1]), Math.abs(p[q + 2] - bg[2]));
    }
    return { c: c, ctx: ctx, data: data, p: p, diff: diff, W: W, H: H, bg: bg };
  }

  /* Find the pendant at the bottom of a product photo and return it on a transparent canvas */
  function cutout(img, forceR) {
    var px = pixels(img, 480), W = px.W, H = px.H, N = W * H, diff = px.diff, p = px.p, i, x, y, n;
    var hi = new Uint8Array(N), lo = new Uint8Array(N);
    for (i = 0; i < N; i++) { hi[i] = diff[i] > 34 ? 1 : 0; lo[i] = diff[i] > 20 ? 1 : 0; }
    var r = forceR;
    if (!r) {
      var runs = [];
      for (y = 2; y < H * 0.14; y++) {
        var cur = 0;
        for (x = 0; x < W; x++) { if (hi[y * W + x]) cur++; else { if (cur) runs.push(cur); cur = 0; } }
      }
      runs.sort(function (a, b) { return a - b; });
      var s = runs.length > 6 ? runs[Math.floor(runs.length * 0.6)] : 2;
      r = Math.min(6, Math.max(1, Math.ceil(s / 2) + 1));
    }
    var opened = filter(filter(hi, W, H, r, false), W, H, r, true);
    var seed = -1;
    for (y = H - 1; y >= 0 && seed < 0; y--) for (x = Math.round(W * 0.15); x < W * 0.85; x++) if (opened[y * W + x]) { seed = y * W + x; break; }
    if (seed < 0) return null;
    var conn = filter(opened, W, H, 3, true);
    var core = new Uint8Array(N), stack = [seed], x0 = W, x1 = 0, y0 = H, y1 = 0;
    core[seed] = 1;
    while (stack.length) {
      i = stack.pop(); y = (i / W) | 0; x = i - y * W;
      if (opened[i]) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
      var nb = [i - 1, i + 1, i - W, i + W, i - W - 1, i - W + 1, i + W - 1, i + W + 1];
      for (var j = 0; j < 8; j++) { n = nb[j]; if (n < 0 || n >= N || core[n] || !conn[n]) continue; core[n] = 1; stack.push(n); }
    }
    var coreW = x1 - x0 + 1, coreH = y1 - y0 + 1, cx = (x0 + x1) / 2;
    if (r > 1 && (coreH > coreW * 3.2 || coreW < W * 0.05)) {
      var retry = cutout(img, r > 3 ? r - 2 : 1);
      if (retry && retry.w * retry.h > coreW * coreH * 1.3) return retry;
    }
    var bailH = Math.round(Math.max(coreH * 0.2, H * 0.02)), bailW = Math.max(coreW * 0.25, 12), shadowGap = Math.max(4, Math.round(coreH * 0.04));
    var grown = new Uint8Array(N);
    stack = [];
    for (i = 0; i < N; i++) if (core[i] && lo[i]) { grown[i] = 1; stack.push(i); }
    while (stack.length) {
      i = stack.pop();
      var four = [i - 1, i + 1, i - W, i + W];
      for (var f = 0; f < 4; f++) {
        n = four[f];
        if (n < 0 || n >= N || grown[n] || !lo[n]) continue;
        var ny = (n / W) | 0, nx = n - ny * W;
        if (ny < y0 - bailH || ny > y1 + shadowGap) continue;
        if (ny < y0 && Math.abs(nx - cx) > bailW / 2) continue;
        if (Math.abs(nx - cx) > coreW * 0.9 + 10) continue;
        grown[n] = 1; stack.push(n);
      }
    }
    var gx0 = W, gx1 = 0, gy0 = H, gy1 = 0;
    for (i = 0; i < N; i++) if (grown[i] || (core[i] && opened[i])) { y = (i / W) | 0; x = i - y * W; if (x < gx0) gx0 = x; if (x > gx1) gx1 = x; if (y < gy0) gy0 = y; if (y > gy1) gy1 = y; }
    var keep = filter(grown, W, H, 2, true), coreD = filter(core, W, H, 1, true);
    for (i = 0; i < N; i++) {
      var alpha = Math.max(0, Math.min(1, (diff[i] - 10) / 34)) * ((keep[i] || coreD[i]) ? 1 : 0);
      p[i * 4 + 3] = Math.round(alpha * 255);
    }
    px.ctx.putImageData(px.data, 0, 0);
    var pad = 3, ox = Math.max(0, gx0 - pad), oy = Math.max(0, gy0 - pad);
    var cw = Math.min(W, gx1 + pad + 1) - ox, ch = Math.min(H, gy1 + pad + 1) - oy;
    var out = document.createElement('canvas');
    out.width = cw; out.height = ch;
    out.getContext('2d').drawImage(px.c, ox, oy, cw, ch, 0, 0, cw, ch);
    return { canvas: out, w: cw, h: ch, r: r };
  }

  /* Lowest point of the hanging chain in its product photo */
  function anchor(img) {
    var px = pixels(img, 600), W = px.W, H = px.H, by = -1, bx = W / 2, p = px.p;
    /* chain metal, not its soft grey shadow: coloured (gold) or clearly darker (silver) pixels */
    function metal(i) {
      var q = i * 4, mx = Math.max(p[q], p[q + 1], p[q + 2]), mn = Math.min(p[q], p[q + 1], p[q + 2]);
      var sat = mx ? (mx - mn) / mx : 0;
      return px.diff[i] > 30 && (sat > 0.18 || px.diff[i] > 75);
    }
    for (var y = H - 1; y > 0 && by < 0; y--) {
      var sx = 0, n = 0;
      for (var x = Math.round(W * 0.3); x < W * 0.7; x++) if (metal(y * W + x)) { sx += x; n++; }
      if (n > 2) { by = y; bx = sx / n; }
    }
    if (by < 0) return null;
    return { canvas: px.c, W: W, H: H, x: bx, y: by, bg: 'rgb(' + px.bg.map(Math.round).join(',') + ')' };
  }

  function getCut(url) {
    if (!cache['c' + url]) cache['c' + url] = load(url).then(function (img) { return cutout(img); });
    return cache['c' + url];
  }
  function getAnchor(url) {
    if (!cache['a' + url]) cache['a' + url] = load(url).then(function (img) { return anchor(img); });
    return cache['a' + url];
  }

  /* Draw the pendant hanging from the chain into canvas. Resolves false when it can't. */
  function render(canvas, opts) {
    return Promise.all([getCut(opts.pendant), getAnchor(opts.chain)]).then(function (res) {
      var cut = res[0], a = res[1];
      if (!cut || !a) return false;
      var size = canvas.width;
      var ctx = canvas.getContext('2d');
      var view = a.H * 0.6;
      var ph = Math.min(view * 0.58, a.H * 0.2 * (opts.scale || 1));
      var pw = ph * cut.w / cut.h;
      if (pw > view * 0.8) { pw = view * 0.8; ph = pw * cut.h / cut.w; }
      var top = a.y - ph * 0.04;
      var cropTop = top + ph + view * 0.1 - view;
      var cropLeft = a.x - view / 2;
      var k = size / view;
      ctx.fillStyle = a.bg;
      ctx.fillRect(0, 0, size, size);
      ctx.drawImage(a.canvas, -cropLeft * k, -cropTop * k, a.W * k, a.H * k);
      ctx.drawImage(cut.canvas, (a.x - pw / 2 - cropLeft) * k, (top - cropTop) * k, pw * k, ph * k);
      return true;
    }).catch(function () { return false; });
  }

  window.WrPairPreview = { render: render };
})();